import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, profile } from 'config/config'; // Importing configuration settings
import PlayersView from 'jet-views/players'; // Importing PlayersView component

/**
 * Class representing the FilterUsersVerificationView.
 * @extends JetView
 */
export default class FilterUsersVerificationView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const id = this.getParam('id', true); // Get the 'id' parameter from the URL
        const vvthis = this; // Reference to the current instance

        // Row 1 configuration with user ID and names
        const row_1 = {
            id: 'r1',
            rows: [
                {
                    margin: 15,
                    responsive: 'r1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            id: 'Id',
                            minWidth: 200,
                            css: 'my_input',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'FirstName',
                            minWidth: 200,
                            label: _('Primer nombre'), // First name label
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'MiddleName',
                            minWidth: 200,
                            label: _('Segundo Nombre'), // Middle name label
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'LastName',
                            minWidth: 200,
                            label: _('Apellido'), // Last name label
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                    ],
                },
            ],
        };

        // Row 2 configuration with additional user details
        const row_2 = {
            id: 'r2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'r2',
                    cols: [
                        {
                            view: 'text',
                            name: 'SecondLastName',
                            minWidth: 200,
                            label: _('Segundo Apellido'), // Second last name label
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'combo',
                            name: 'Gender',
                            minWidth: 200,
                            label: _('Género'), // Gender label
                            labelPosition: 'top',
                            options: [
                                { id: 'M', value: _('Masculino') }, // Male option
                                { id: 'F', value: _('Femenino') }, // Female option
                            ],
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'BirthDate',
                            minWidth: 200,
                            label: _('Fecha de Nacimiento'), // Birth date label
                            labelPosition: 'top',
                            disabled: true, // Field is disabled
                        },
                        {
                            hidden: !devConfig.getPermAction('viewMobilePhoneManagement', 'Add'), // Oculta el campo si el usuario no tiene permiso para visualizar los celulares.
                            view: "text", // Tipo de componente (campo de texto).
                            name: "MobilePhone", // Nombre identificador del campo.
                            minWidth:200, // Ancho mínimo del campo en píxeles.
                            label: _("Celular"), // Etiqueta visible con soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            disabled: true // Deshabilita el campo para solo visualización.
                        }
                    ]
                }
            ]
        };

        // Row 3 configuration with location details
        const row_3 = {
            id: 'r3',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'r3',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'CountryId',
                            id: 'country',
                            localId: 'country:combo',
                            minWidth: 200,
                            label: _('País Residencia'), // Country label
                            labelPosition: 'top',
                            options: [], // Options will be populated dynamically
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'richselect',
                            name: 'RegionId',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            minWidth: 200,
                            label: _('Provincia/Región Residencia'), // Region label
                            labelPosition: 'top',
                            options: [], // Options will be populated dynamically
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'richselect',
                            name: 'CityId',
                            id: 'City',
                            localId: 'cities:combo',
                            minWidth: 200,
                            label: _('Ciudad Residencia'), // City label
                            labelPosition: 'top',
                            options: [], // Options will be populated dynamically
                            disabled: true, // Field is disabled
                        },
                        {
                            hidden: !devConfig.getPermAction('viewAddressManagement', 'Add'), // Oculta el campo si el usuario no tiene permiso para visualizar las direcciones.
                            view: "text", // Tipo de componente (campo de texto).
                            name: "Address", // Nombre identificador del campo.
                            label: _("Dirección"), // Etiqueta visible con soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            minWidth: 200, // Ancho mínimo del campo en píxeles.
                            disabled: true // Deshabilita el campo para solo visualización.
                        }
                    ]
                }
            ]
        };

        // Row 4 configuration with document details
        const row_4 = {
            id: 'r4',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'r4',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'DocumentType',
                            localId: 'DocumentType:combo',
                            label: _('Tipo de Documento'), // Document type label
                            labelPosition: 'top',
                            options: [
                                { id: 'C', value: _('DNI') }, // DNI option
                                { id: 'E', value: _('Cedula de Extranjería') }, // Foreign ID option
                                { id: 'P', value: _('Pasaporte') }, // Passport option
                            ],
                            disabled: true, // Field is disabled
                        },
                        {
                            view: 'text',
                            name: 'DocNumber',
                            minWidth: 200,
                            label: _('Número de Documento'), // Document number label
                            labelPosition: 'top',
                            disabled: false, // Field is editable
                        },
                        {
                            hidden: !devConfig.getPermAction('viewEmailUserVerification', 'Add'), // Oculta el campo si el usuario no tiene permiso para visualizar los correos electronicos.
                            view: "text", // Tipo de componente (campo de texto).
                            name: "Email", // Nombre identificador del campo.
                            minWidth:200, // Ancho mínimo del campo en píxeles.
                            label: _("Email"), // Etiqueta visible con soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            disabled: true // Deshabilita el campo para solo visualización.
                        },
                        { gravity: 1, id: 'grav', minWidth: 200 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Row 5 configuration (empty row for future use)
        const row_5 = {
            id: 'r5',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'r5',
                    height: 0, // Height set to 0
                    id: 'rw5',
                    cols: [], // No columns defined
                },
            ],
        };

        // Row 6 configuration (empty row for future use)
        const row_6 = {
            id: 'r6',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'r6',
                    height: 0, // Height set to 0
                    id: 'rw6',
                    cols: [], // No columns defined
                },
            ],
        };

        // Row 7 configuration with previews of documents
        const row_7 = {
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    id: 'r7',
                    rows: [
                        {
                            responsive: 'r7',
                            id: 'rs',
                            cols: [
                                {
                                    rows: [
                                        {
                                            view: 'label',
                                            align: 'center',
                                            label: _('DNI Anterior'), // Previous DNI label
                                            minWidth: 200,
                                            css: 'my-label-vc',
                                        },
                                        {
                                            id: 'previewAnt',
                                            view: 'template',
                                            css: 'preview2',
                                            border: 0,
                                            template:
                                                '<div class="divPreviewImage showModal"><img class="previewImage2" src="#src#"></div>', // Template for previous DNI preview
                                            data: { src: null }, // Initial data
                                            minWidth: 200,
                                            minHeight: 200,
                                            onClick: {
                                                showModal: function (ev, id) {
                                                    webix
                                                        .ui({
                                                            view: 'window',
                                                            move: true,
                                                            width: screen.width < 500 ? 350 : 500,
                                                            height: screen.width < 500 ? 350 : 500,
                                                            head: {
                                                                view: 'toolbar',
                                                                cols: [
                                                                    {
                                                                        view: 'label',
                                                                        label: _('DNI Anterior'), // Modal title
                                                                        align: 'center',
                                                                    },
                                                                    {
                                                                        view: 'icon',
                                                                        icon: 'wxi-close',
                                                                        click: function () {
                                                                            this.getTopParentView().hide(); // Close modal
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            modal: true,
                                                            position: 'center',
                                                            body: {
                                                                rows: [
                                                                    {
                                                                        template: function (obj) {
                                                                            return (
                                                                                "<img src='" +
                                                                                $$('previewAnt').getValues().src +
                                                                                "' style='width:100%; height:100%;'>"
                                                                            ); // Display image in modal
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                        .show(); // Show modal
                                                },
                                            },
                                        },
                                    ],
                                },
                                {
                                    rows: [
                                        {
                                            view: 'label',
                                            align: 'center',
                                            label: _('DNI Posterior'), // Current DNI label
                                            minWidth: 200,
                                            css: 'my-label-vc',
                                        },
                                        {
                                            id: 'previewPos',
                                            view: 'template',
                                            css: 'preview2',
                                            template:
                                                '<div class="divPreviewImage showModal"><img class="previewImage2" src="#src#"></div>', // Template for current DNI preview
                                            data: { src: null }, // Initial data
                                            minWidth: 200,
                                            minHeight: 200,
                                            onClick: {
                                                showModal: function (ev, id) {
                                                    webix
                                                        .ui({
                                                            view: 'window',
                                                            move: true,
                                                            width: screen.width < 500 ? 350 : 500,
                                                            height: screen.width < 500 ? 350 : 500,
                                                            head: {
                                                                view: 'toolbar',
                                                                cols: [
                                                                    {
                                                                        view: 'label',
                                                                        label: _('DNI Posterior'), // Modal title
                                                                        align: 'center',
                                                                    },
                                                                    {
                                                                        view: 'icon',
                                                                        icon: 'wxi-close',
                                                                        click: function () {
                                                                            this.getTopParentView().hide(); // Close modal
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            modal: true,
                                                            position: 'center',
                                                            body: {
                                                                rows: [
                                                                    {
                                                                        template: function (obj) {
                                                                            return (
                                                                                "<img src='" +
                                                                                $$('previewPos').getValues().src +
                                                                                "' style='width:100%; height:100%;'>"
                                                                            ); // Display image in modal
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                        .show(); // Show modal
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Button configuration for approval and rejection
        const button = {
            id: 'r8',
            rows: [
                {
                    margin: 10,
                    responsive: 'r8',
                    cols: [
                        {
                            view: 'button',
                            id: 'buttonA',
                            value: _('Aprobar'), // Approve button label
                            type: 'form',
                            click: () => {
                                const newdata = this.getRoot().getValues(); // Get form values
                                webix
                                    .ui({
                                        view: 'window',
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Desea aprobar cuenta?'),
                                                    align: 'center',
                                                }, // Confirmation message
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'formAcep',
                                            elements: [
                                                {
                                                    view: 'textarea',
                                                    label: _('Nota'), // Note label
                                                    name: 'Note',
                                                    required: true,
                                                    labelPosition: 'top',
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'), // Cancel button label
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close modal
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: _('Aprobar'), // Approve button label
                                                            click: function ($e) {
                                                                var valuesForm = $$('formAcep').getValues(); // Get form values
                                                                if ($$('formAcep').validate()) {
                                                                    // Validate form
                                                                    var vthis = this;
                                                                    var params = {
                                                                        Id: id,
                                                                        UserId: newdata.Id,
                                                                        Note: valuesForm.Note,
                                                                        State: 'A', // Approval state
                                                                    };
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json',
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Client/verifyAccount2', // API endpoint for verification
                                                                            params,
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    vthis.getTopParentView().hide(); // Close modal on error
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var data = JSON.parse(text); // Parse response
                                                                                    if (data.HasError) {
                                                                                        webix.message({
                                                                                            title: _('¡Error!'), // Error message title
                                                                                            type: 'alert-error',
                                                                                            text: _(data.AlertMessage), // Error message text
                                                                                        });
                                                                                    }
                                                                                    vthis.getTopParentView().hide(); // Close modal
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('buttonA').define('disabled', true); // Disable approve button
                                                                    $$('buttonR').define('disabled', true); // Disable reject button
                                                                    this.getTopParentView().hide(); // Close modal
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'), // Error message title
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'), // Error message text
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show modal
                            },
                        },
                        {
                            view: 'button',
                            id: 'buttonR',
                            value: _('Rechazar'), // Reject button label
                            type: 'form',
                            click: () => {
                                const newdata = this.getRoot().getValues(); // Get form values
                                webix
                                    .ui({
                                        view: 'window',
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Desea rechazar usuario?'),
                                                    align: 'center',
                                                }, // Confirmation message
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'formRech',
                                            elements: [
                                                {
                                                    view: 'textarea',
                                                    label: _('Nota'), // Note label
                                                    name: 'Note',
                                                    required: true,
                                                    labelPosition: 'top',
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'), // Cancel button label
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close modal
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: _('Rechazar'), // Reject button label
                                                            click: function ($e) {
                                                                var valuesForm = $$('formRech').getValues(); // Get form values
                                                                if ($$('formRech').validate()) {
                                                                    // Validate form
                                                                    var vthis = this;
                                                                    var params = {
                                                                        Id: id,
                                                                        UserId: newdata.Id,
                                                                        Note: valuesForm.Note,
                                                                        State: 'I', // Rejection state
                                                                    };
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json',
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Client/verifyAccount2', // API endpoint for verification
                                                                            params,
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    vthis.getTopParentView().hide(); // Close modal on error
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var data = JSON.parse(text); // Parse response
                                                                                    if (data.HasError) {
                                                                                        webix.message({
                                                                                            title: _('¡Error!'), // Error message title
                                                                                            type: 'alert-error',
                                                                                            text: _(data.AlertMessage), // Error message text
                                                                                        });
                                                                                    }
                                                                                    vthis.getTopParentView().hide(); // Close modal
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('buttonA').define('disabled', true); // Disable approve button
                                                                    $$('buttonR').define('disabled', true); // Disable reject button
                                                                    this.getTopParentView().hide(); // Close modal
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'), // Error message title
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'), // Error message text
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show modal
                            },
                        },
                    ],
                },
            ],
        };

        // Content configuration for the form
        const content = {
            rows: [row_1, row_2, row_3, row_4], // Rows containing user information
        };

        // Additional content configuration with new fields
        const content2 = {
            css: 'content2',
            rows: [
                {
                    view: 'label',
                    align: 'center',
                    label: _('Nuevos campos'),
                    minWidth: 200,
                    margin: 10,
                }, // New fields label
                row_5,
                row_6,
                row_7,
            ],
        };

        // Scrollable content configuration
        const contentscroll = {
            view: 'scrollview',
            scroll: 'xy',
            css: 'my-scrollview-vc',
            body: {
                rows: [content, content2], // Body containing the main content
            },
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            view: 'form',
            id: 'form',
            rows: [
                {
                    rows: [contentscroll, button], // Main form layout
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        webix.ready(function () {
            $$('previewAnt').setValues({
                src: 'https://i.stack.imgur.com/lnYep.png',
            }); // Set initial image for previous DNI
            $$('previewPos').setValues({
                src: 'https://i.stack.imgur.com/lnYep.png',
            }); // Set initial image for current DNI
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"')); // Parse country data
                        var optionsCountries = $$('country').getList(); // Get country list
                        optionsCountries.clearAll(); // Clear existing options
                        optionsCountries.parse(data.Data); // Populate country options
                    },
                });
            $$('country').attachEvent('onChange', function (newv, oldv) {
                var optionscountries = this.getList().getItem(newv); // Get selected country
                var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Get province/region list
                optionsProvinceRegions.clearAll(); // Clear existing options
                if (optionscountries != undefined) {
                    optionsProvinceRegions.parse(optionscountries.departments); // Populate province/region options
                }
            });
            $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
                var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province/region
                var optionsCity = $$('City').getList(); // Get city list
                optionsCity.clearAll(); // Clear existing options
                if (optionsProvinceRegions != undefined) {
                    optionsCity.parse(optionsProvinceRegions.cities); // Populate city options
                }
            });
        });
        const cur_user = this.getParam('user', true); // Get current user ID from parameters
        const id = this.getParam('id', true); // Get ID from parameters
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .get(devConfig.geturlApi() + 'es/Client/GetClientById?id=' + cur_user, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var userSelected = []; // Array to hold selected user data
                    $$('form').clear(); // Clear the form
                    var userSelected2 = [
                        {
                            DNIA: 'https://i.stack.imgur.com/lnYep.png',
                            DNIP: 'https://i.stack.imgur.com/lnYep.png',
                        }, // Initial user images
                    ];
                    $$('form').parse(userSelected2); // Populate form with initial data
                    if (text != '') {
                        var resp = JSON.parse(text); // Parse response
                        if (resp.length > 0) {
                            if (screen.width > 500) {
                                $$('lblTittle').setValue(
                                    "<div class='username-active'><span class='icon-user'></span><div style='font-weight: normal'>" +
                                        _('Usuario:') +
                                        ' &nbsp;</div><div>' +
                                        resp[0].Login +
                                        '</div></div>', // Set user title
                                );
                            } else {
                                $$('lblTittle').setValue('<div>' + resp[0].Login + '</div>'); // Set user title for small screens
                            }
                            userSelected.push(resp[0]); // Add user data to the array
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json',
                                })
                                .get(
                                    devConfig.geturlApi() +
                                        'UserManagement/GetUserLogs?Id=' +
                                        cur_user +
                                        '&Verified=' +
                                        id, // Get user logs
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var resp2 = JSON.parse(text); // Parse logs response
                                            if (resp2.Data.length > 0) {
                                                resp2.Data.forEach((item2) => {
                                                    if (item2.Field == 'DNI Anterior') {
                                                        if (item2.StateId == 'P' || true) {
                                                            $$('previewAnt').setValues({
                                                                src: item2.Imagen,
                                                            }); // Set previous DNI image
                                                        }
                                                    }
                                                    if (item2.Field == 'DNI Posterior') {
                                                        if (item2.StateId == 'P' || true) {
                                                            $$('previewPos').setValues({
                                                                src: item2.Imagen,
                                                            }); // Set current DNI image
                                                        }
                                                    }
                                                    if (item2.Field == 'Foto Usuario') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rs').addView({
                                                                    rows: [
                                                                        {
                                                                            view: 'label',
                                                                            align: 'center',
                                                                            label: _('Selfie'), // Selfie label
                                                                            minWidth: 200,
                                                                            css: 'my-label-vc',
                                                                        },
                                                                        {
                                                                            id: 'selfie',
                                                                            view: 'template',
                                                                            css: 'preview2',
                                                                            template:
                                                                                '<div class="divPreviewImage showModal"><img class="previewImage2" src="#src#"></div>', // Template for selfie preview
                                                                            data: {
                                                                                src: null,
                                                                            }, // Initial data
                                                                            minWidth: 200,
                                                                            minHeight: 200,
                                                                            onClick: {
                                                                                showModal: function (ev, id) {
                                                                                    webix
                                                                                        .ui({
                                                                                            view: 'window',
                                                                                            move: true,
                                                                                            width:
                                                                                                screen.width < 500
                                                                                                    ? 350
                                                                                                    : 500,
                                                                                            height:
                                                                                                screen.width < 500
                                                                                                    ? 350
                                                                                                    : 500,
                                                                                            head: {
                                                                                                view: 'toolbar',
                                                                                                cols: [
                                                                                                    {
                                                                                                        view: 'label',
                                                                                                        label: _(
                                                                                                            'Selfie', // Modal title
                                                                                                        ),
                                                                                                        align: 'center',
                                                                                                    },
                                                                                                    {
                                                                                                        view: 'icon',
                                                                                                        icon: 'wxi-close',
                                                                                                        click: function () {
                                                                                                            this.getTopParentView().hide(); // Close modal
                                                                                                        },
                                                                                                    },
                                                                                                ],
                                                                                            },
                                                                                            modal: true,
                                                                                            position: 'center',
                                                                                            body: {
                                                                                                rows: [
                                                                                                    {
                                                                                                        template:
                                                                                                            function (
                                                                                                                obj,
                                                                                                            ) {
                                                                                                                return (
                                                                                                                    "<img src='" +
                                                                                                                    item2.Imagen +
                                                                                                                    "' style='width:100%; height:100%;'>"
                                                                                                                ); // Display image in modal
                                                                                                            },
                                                                                                    },
                                                                                                ],
                                                                                            },
                                                                                        })
                                                                                        .show(); // Show modal
                                                                                },
                                                                            },
                                                                        },
                                                                    ],
                                                                });
                                                                $$('selfie').setValues({
                                                                    src: item2.Imagen,
                                                                }); // Set selfie image
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Cedula (ID)') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw5').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'DocNumberNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Número de Documento'), // New document number label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Email') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw5').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'EmailNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Email'), // New email label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Primer Nombre') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw5').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'FirstNameNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Primer Nombre'), // New first name label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Segundo Nombre') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw5').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'MiddleNameNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Segundo Nombre'), // New middle name label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Primer Apellido') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'LastNameNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Primer Apellido'), // New last name label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Segundo Apellido') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'SecondLastNameNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Segundo Apellido'), // New second last name label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Fecha de Nacimiento') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'BirthDateNew',
                                                                            minWidth: 200,
                                                                            label: _('Nueva fecha de nacimiento'), // New birth date label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Celular') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'PhoneNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Celular'), // New mobile label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Direccion') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'AddressNew',
                                                                            minWidth: 200,
                                                                            label: _('Nueva Dirección'), // New address label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Juego Casino Favorito') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'CasinoGameNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Juego Casino Favorito'), // New favorite casino game label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Deporte Favorito') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'FavoriteDeportNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Deporte Favorito'), // New favorite sport label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Equipo Favorito') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'FavoriteTeamNew',
                                                                            minWidth: 200,
                                                                            label: _('Nuevo Equipo Favorito'), // New favorite team label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Ciudad Residencia') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'RecidentCityNew',
                                                                            minWidth: 200,
                                                                            label: _('Nueva Ciudad Residencia'), // New residence city label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                    if (item2.Field == 'Verificacion de Direccion') {
                                                        if (item2.StateId == 'P' || true) {
                                                            setTimeout(() => {
                                                                $$('rw6').addView({
                                                                    cols: [
                                                                        {
                                                                            view: 'text',
                                                                            name: 'ServicesNew',
                                                                            minWidth: 200,
                                                                            label: _('Servicios'), // New services label
                                                                            labelPosition: 'top',
                                                                            value: item2.NewValue, // Set new value
                                                                            disabled: true, // Field is disabled
                                                                        },
                                                                    ],
                                                                });
                                                            }, 1000);
                                                        }
                                                    }
                                                });
                                                if (resp2.data[0].StateId != 'P') {
                                                    $$('buttonA').define('disabled', true); // Disable approve button if not in 'P' state
                                                    $$('buttonR').define('disabled', true); // Disable reject button if not in 'P' state
                                                }
                                                $$('form').resize(); // Resize form
                                            } else {
                                                $$('buttonA').define('disabled', true); // Disable approve button if no logs
                                                $$('buttonR').define('disabled', true); // Disable reject button if no logs
                                            }
                                            $$('form').parse(userSelected); // Populate form with user data
                                        },
                                    },
                                );
                        }
                    }
                },
            });
    }
}

// FILE DOCUMENTED
